import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'app-maint-request',
  templateUrl: './maint-request.component.html',
  styleUrls: ['./maint-request.component.css']
})
export class MaintRequestComponent implements OnInit {

  public menu_item_id = '80';
  public add_auth;

  model = {
    'table_name': 'qutation', 'qutation_no': '', 'qutation_date': '', 'expiry_date': '',
    'customer_no': '', 'customer_name': '', 'calc_tax': '1', 'print_tax': '1', 'total': '', 'tax': '', 
    'discount': '', 'meter_reading': '', 'cond_list_id': '0', 
    'branch_id': this.applicationConstants.user_branch_info.user_branch_id,
  };

  data_model = {
    'requestDate': new Date(), 'appointDate': new Date(), 'hours': '00', 'minutes': '00',
    'final_total': ''
  };

  search_obj = {
    'placeholder': '', 'class_name': 'longSearchField',
    'table_list': [{
      'table_name': '`customer`', 'selected_no': 'acct_number',
      'field_list': ['acct_number', 'customer_name', 'customer_name_en', 'represent1'],
      'condition': " AND `branch_id` = '" + this.model['branch_id'] + "'"
    }]
  };

  hoursList = [];
  minutesList = [];
  dp = [];

  carDetail = '';
  carList = [];

  Car_Search_Field;
  Select_Car_Msg;
  Request_Date_Msg;
  Appoint_Date_Msg;
  Meter_Reading_Msg;
  Item_Msg;
  Success_Msg;
  Error_Msg;
  Request_No;


  constructor(private utils: Utils, private applicationConstants: ApplicationConstants,
    private queryList: QueryList, public dialog: MatDialog, private router: Router,
    public translate: TranslateService) {

    this.getMessages(translate);
  }

  getMessages(translate) {
    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    translate.get('Car_Search_Field').subscribe((res: string) => {
      this.Car_Search_Field = res;
    });
    this.search_obj['placeholder'] = this.Car_Search_Field;


    translate.get('Select_Car_Msg').subscribe((res: string) => {
      this.Select_Car_Msg = res;
    });

    translate.get('Request_Date_Msg').subscribe((res: string) => {
      this.Request_Date_Msg = res;
    });

    translate.get('Appoint_Date_Msg').subscribe((res: string) => {
      this.Appoint_Date_Msg = res;
    });

    translate.get('Meter_Reading_Msg').subscribe((res: string) => {
      this.Meter_Reading_Msg = res;
    });

    translate.get('Item_Msg').subscribe((res: string) => {
      this.Item_Msg = res;
    });

    translate.get('Success_Msg').subscribe((res: string) => {
      this.Success_Msg = res;
    });

    translate.get('Error_Msg').subscribe((res: string) => {
      this.Error_Msg = res;
    });

    translate.get('Request_No').subscribe((res: string) => {
      this.Request_No = res;
    });
  }

  ngOnInit() {

    // get leaf customer accts
    // this.carList = this.applicationConstants.customerList;
    
    // let branch_list = [{ 'branch_id': this.model['branch_id'] }];
    // let parent_acct = this.applicationConstants.main_acct_config['customer'];
    // let obj = { cmd: 'getAccountList', parent_acct: parent_acct, add_leaf: true, only_leaf: true, 
    //   check_cc: false, type: 'customer', branch_list: branch_list };
    // this.utils.invokeHttp(this.applicationConstants.functionFile, obj)
    //   .subscribe(data => {
    //     this.applicationConstants.appComp.hideBusyCursor();
    //     this.carList = data.data['list'];
    //   });


    // check add authorization
    this.add_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.ADD_AUTH);

    // fill hoursList
    let value = '';

    for (let i = 0; i < 24; i++) {
      if (i >= 0 && i < 10)
        value = '0' + i;
      else
        value = String(i);

      this.hoursList.push({ key: value, value: value });
    }

    // fill minutesList
    for (let i = 0; i < 60; i++) {
      if (i >= 0 && i < 10)
        value = '0' + i;
      else
        value = String(i);

      this.minutesList.push({ key: value, value: value });
    }
  }

  onChangeSearch = function (search_result: object) {
    // console.log(search_result);
    this.model['customer_name'] = search_result['value'];
    this.model['customer_no'] = search_result['no'];
  }

  onChange = function (dpList: any) {
    this.dp = dpList['dp'];
  }

  // onChangeCar = function (acct_number: string) {
  //   console.log(acct_number);

  //   this.model['customer_no'] = acct_number;
  //   this.model['customer_name'] = (document.getElementById('search_value_0') as HTMLInputElement).value;
  // }

  saveRequest() {
    if (this.model['customer_no'] == '' || this.model['customer_no'] == '0') {
      alert(this.Select_Car_Msg);
      (document.getElementById('search_value_0') as HTMLInputElement).focus();
      return false;
    }
    if ((document.getElementById('requestDate') as HTMLInputElement).value == '') {
      alert(this.Request_Date_Msg);
      (document.getElementById('requestDate') as HTMLInputElement).focus();
      return false;
    }
    if ((document.getElementById('appointDate') as HTMLInputElement).value == '') {
      alert(this.Appoint_Date_Msg);
      (document.getElementById('appointDate') as HTMLInputElement).focus();
      return false;
    }
    if (this.model['meter_reading'] == '' || this.model['meter_reading'] == '0') {
      alert(this.Meter_Reading_Msg);
      document.getElementById('search_value_0').focus();
      return false;
    }
    if (this.model['total'] == '' || Number(this.model['total']) == 0) {
      alert(this.Item_Msg);
      return false;
    }

    this.model['qutation_date'] = this.data_model['requestDate'].getFullYear() + "-" +
      (this.data_model['requestDate'].getMonth() + 1) + "-" + this.data_model['requestDate'].getDate() + " " +
      (new Date()).getHours() + ':' + (new Date()).getMinutes() + ':' + (new Date()).getSeconds();

    this.model['expiry_date'] = this.data_model['appointDate'].getFullYear() + "-" +
      (this.data_model['appointDate'].getMonth() + 1) + "-" + this.data_model['appointDate'].getDate() + " " +
      this.data_model['hours'] + ':' + this.data_model['minutes'] + ':00';


    let values = [];
    values.push(this.model);

    this.dp.forEach(element => {

      if (element.sub_item_number != '' || (element.sub_item_name != '' && element.total_price != '')) {
        values.push({
          'table_name': 'qutation_item', 'qutation_no': this.model['qutation_no'], 'sub_item_number': element.sub_item_number,
          'sub_item_name': element.sub_item_name, 'count': element.count, 'price': element.price, 'unit_id': element.unit_id,
          'total_price': element.total_price, 'tax_no': element.tax_no, 'tax_amount': element.tax_amount,
          'discount': element.discount, 'comment': element.comment
        });
      }
    });

    let current_year = new Date().getFullYear();
    let prefix = this.applicationConstants.branch_id + "-" + current_year;
    let obj = {
      cmd: 'add', values: values, pk: 'qutation_no', id: 'qutation_id', main_table: 'qutation',
      prefix: prefix
    };
    //console.log(values);
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        if (data.status['type'] == 'success') {
          let qutation_no = data.status['msg'][0]['number'];
          alert(this.Success_Msg + " ، " + this.Request_No + qutation_no);
          this.router.navigate(['sub_menu/12/qutation_list']);
          window.open(this.applicationConstants.generatePDF + "?type=qutation&is_maint=1&no=" + qutation_no, "_blank");
        }
        else
          alert(this.Error_Msg);
      });

  }

}
